<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-05 15:12:57
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-07 11:04:38
-->
<template>
	<div>
		<el-drawer title="确认达人最终跟进人" :visible.sync="drawer" :direction="direction" :wrapperClosable="false" size="900">
			<el-alert :closable="false">
				<template #title>
					<i class="el-icon-info"></i>
					<span class="yx-color-text-primary">
						共计
						{{ talentNum }}
						个达人有多个达人商务跟进，重新确认达人与达人商务1对1跟进关系后，其余达人商务关于该达人的合作进度将由最终跟进达人商务继承
					</span>
				</template>
			</el-alert>
			<el-table :data="talentList" :span-method="arraySpanMethod" border style="width: 95%">
				<el-table-column label="达人信息" width="383">
					<template v-slot="{ row }">
						<talent-info :row="row" :platformId="platformId" :showID="false"></talent-info>
						<div class="error fz-12" v-if="row.checked">
							<i class="el-icon-warning mr-8"></i>
							请选择跟进人
						</div>
					</template>
				</el-table-column>
				<el-table-column label="达人商务" width="370px">
					<template v-slot="{ row }">
						<div
							:class="['partners', 'flex', !index ? 'top' : index + 1 === row.partners.length ? 'bottom' : 'middle']"
							v-for="(item, index) in row.partners"
							:key="index"
						>
							<p>{{ item.partner_role_name }}</p>
							<label v-if="$auth.hasPermi('system:talent:allocation/re-allocation')">
								<input type="radio" value="checked" @change="radioFun(row.partners, index)" :name="row.anchor_id" v-model="item.checked" />
								<span class="el-radio__label">设为最终跟进人</span>
							</label>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" v-if="$auth.hasPermi('system:talent:allocation/re-allocation')"></el-table-column>
			</el-table>
			<div class="flex flex-just-end mb-16 ml-24 mr-24">
				<el-button size="medium" @click="closeDrawer">取消</el-button>
				<el-button size="medium" class="subBtn" @click="submit">确定</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { getWaitFix, addFixTask, getPartnerAnchor } from '@/api/talentCRM';
import talentInfo from '../talentInfo';
import throttle from 'lodash/throttle';
export default {
	data() {
		return {
			drawer: false,
			anchorCount: 0,
			direction: 'rtl',
			talentList: [],
			radio: '',
			platformId: '',
			groups: {},
			count: [], //用于传递合并单元格方法的数据
			submitData: [],
			select_anchors: {},
		};
	},
	computed: {
		talentNum() {
			return this.talentList.length;
		},
	},
	components: {
		talentInfo,
	},
	methods: {
		show(val) {
			this.platformId = val;
			this.drawer = true;
			this.getTanlentData();
		},
		async getTanlentData() {
			const { code, data = [] } = await getWaitFix({ platform_id: this.platformId });
			if (code !== 0) return;
			this.talentList = data;
		},
		async getTalentStatus() {
			const res = await getPartnerAnchor({ platform_id: this.platformId });
		},
		arraySpanMethod({ columnIndex }) {
			if (columnIndex === 1) {
				return [1, 2];
			}
		},
		radioFun(list, index) {
			list.forEach((item, ind) => {
				if (index !== ind) {
					delete item['checked'];
				}
			});
		},
		closeDrawer() {
			this.drawer = false;
		},
		groupBy(data, params) {
			const groups = {};
			data.forEach(v => {
				const group = JSON.stringify(v[params]);
				// 把group作为groups的key，初始化value，循环时找到相同的v[params]时不变
				groups[group] = groups[group] || [];
				// 将对应找到的值作为value放入数组中
				groups[group].push(v);
			});
			// 返回处理好的二维数组 （如果想返回groupBy形式的数据只返回groups即可）
			return Object.values(groups);
		},
		//将上述处理好的数组进行合并预处理，需要得到rowIndex
		setArr(data, params) {
			let arr = [];
			if (Array.isArray(data)) {
				arr = data.flat(Infinity);
			}
			for (let i = 0; i < arr.length; i++) {
				arr[i].index = i;
			}
			this.list = arr; //数组扁平化以后赋值给原始数据
			const redata = arr.map(v => v[params]);
			let post = 1; //用于计数
			let targetIndex = 0; //需要修改数据的目标索引
			redata.reduce((pre, cur, i) => {
				//我们需要确定索引，当前项如果与上一项一样，那么索引对应的值加1，加一个占位符0，如果不一样，那么重新确定索引
				if (i === 0) {
					this.count.push(1);
				} else if (cur === pre) {
					post++;
					this.count.push(0);
					this.count[targetIndex] = post;
				} else {
					this.count.push(1);
					targetIndex = i; //当遇到不同的数据时候需要记录当前的i
					post = 1;
				}
				return cur;
			}, '');
		},
		submit: throttle(async function () {
			this.submitData = [];
			let state_list = [];
			this.talentList.forEach((item, index) => {
				item.partners.forEach(v => {
					if (v.checked) {
						this.submitData.push({ anchor_id: item.anchor_id, user_id: v.user_id });
					}
				});
				let isChecked = item.partners.some(v => v.checked);
				if (isChecked) {
					this.$set(this.talentList[index], 'checked', false);
				} else {
					this.$set(this.talentList[index], 'checked', true);
				}
				state_list.push(isChecked);
			});
			if (state_list.indexOf(false) !== -1) return this.$message.error('请选择达人运营');
			let params = {
				many_partner: 0,
				platform_id: this.platformId,
				bind_list: this.submitData,
			};
			await addFixTask(params);
			this.$emit('changeStatus', 2);
			this.$emit('getTaskStatus');
			this.drawer = false;
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-table {
	margin-left: 24px;
	margin-bottom: 16px;
}

.el-alert {
	background-color: #e9f1ff;
	border: 1px solid #bdd5ff;
	margin: 16px 24px;
	width: 95%;
}

.el-icon-info {
	color: @color-primary;
	margin-right: 5px;
}

.subBtn {
	background-color: @color-primary;
	color: #ffffff;
}

.partners {
	display: flex;
	justify-content: space-between;

	p {
		margin-left: 4px;
	}
}

/deep/ .el-table th.is-leaf {
	border-bottom: 1px solid #e3e3e3 !important;
	border-right: none;
}

.top {
	padding-bottom: 16px;
}

.middle {
	border-top: 1px solid #eeeeee;
	padding: 16px 0px;
}

.bottom {
	border-top: 1px solid #eeeeee;
	padding-top: 16px;
}

.error {
	color: red;
}
</style>
